import React from 'react';
import { Link } from 'react-router-dom';


const Sobre = () => {
  return (
<div>
  <div id="titulo">
    <h1>Sobre a Criar</h1>
  </div>
  <div id = "texto2">  
  <h2>Nossa História</h2>
    <p>A Criar Tecnologia foi fundada em maio de 1991, na Capital de São Paulo. No início de suas atividades focava no desenvolvimento de sistemas e aplicativos sob medida. Os primeiros programas desenvolvidos foram: contabilidade registro de vendas emissão de nota fiscal. Com o passar do tempo e o ganho de experiência nas questões de automação comercial e de gestão empresarial, a Criar Tecnologia passou a desenvolver sistemas próprios. Hoje estes sistemas se transformaram em produtos e estão bastante consolidados e aceitos em diversos clientes. Além disso, a área de atuação da Criar Tecnologia foi expandida para as principais cidades do Estado de São Paulo e para as principais capitais do Brasil.</p>
  

  <h2>Valores, Visão e Missão</h2>
    <p>Propondo sempre a melhor solução para alcançar os melhores resultados, esta é a principal missão da Criar Tecnologia. Buscamos sempre a entrega de aplicativos altamente confiáveis, certificados e com capacidade de adaptação a cada negócio. O Desenvolvimento e o crescimento da sua empresa devem passar sempre por implementação de novas tecnologias e soluções inovadoras. A Criar, com diversos casos de sucesso e alto índice de satisfação de clientes, é a empresa que pode auxiliá-lo.</p>
    <Link to="/termos" id='link_css'>Termos da Criar Tecnologia</Link>
  </div>
</div>
)
};

export default Sobre;
